/**
 * Sprint 2b risk-event configuration: rug pulls and the loss-aversion
 * ad hooks (panic exit / rug insurance / trade rewind).
 */

export const RUG_CONFIG = {
  /** chance a rug pull starts right after a pump ends (whale or scenario) */
  chance: 0.15,
  /** crash phase duration (price slides to the target) */
  crashMin: 10_000,
  crashMax: 20_000,
  /** total drop fraction of the pre-crash price */
  dropMin: 0.7,
  dropMax: 0.9,
  /** floor phase: price crawls sideways at the bottom (3~5 min) */
  floorMin: 180_000,
  floorMax: 300_000,
  /** recovery phase: mild upward bias, then normal mean reversion */
  recoverDuration: 180_000,
  /** recovery bias in volatility units per tick */
  recoveryBias: 0.8,
  /** floor wander noise (fraction of price per tick) */
  floorNoise: 0.02,
} as const;

export const PANIC_CONFIG = {
  /** fraction of the holding sold by a panic exit */
  sellRatio: 0.5,
  /** "pre-crash price" lookback window */
  refWindow: 30_000,
  /** rug-path panic stays valid this long into the floor phase (ad-length grace) */
  rugGraceAfterCrash: 45_000,
  /** generic crash detection: drop percent within refWindow */
  crashDropPct: 25,
  /** per-coin lock after use (also enforces once per rug event) */
  cooldown: 180_000,
  /** rolling price samples kept per coin (covers refWindow at 2s ticks) */
  maxSamples: 25,
  sampleInterval: 2000,
} as const;

export const INSURANCE_CONFIG = {
  /** policy lifetime after activation */
  duration: 1_800_000,
  /** payout = pre-crash position value * ratio */
  payoutRatio: 0.7,
  /** buy-offer banner lifetime after a meme-coin buy */
  offerDuration: 10_000,
} as const;

export const REWIND_CONFIG = {
  /** hook is displayed while the trade is at most this old */
  window: 60_000,
  /** grace so an ad started near the end of the window still lands */
  executeWindow: 90_000,
  /** adverse move percent vs the fill price that arms the hook */
  adversePct: 8,
  /** cooldown after use (20h - simplified daily limit) */
  cooldown: 72_000_000,
} as const;
